module.exports = __webpack_public_path__ + "img/jcb.42256e80.svg";